import { User } from '@/store/user.ts'
import { ParticipantT } from '@/routes/settings/projectDetails/lib/types.ts'

type UserFormat = User | ParticipantT['participant'] | null | undefined

export const formatUserName = (user: UserFormat) => {
  if (!user) {
    return ''
  }

  const { name, surname, email } = user

  if (name && surname) {
    return `${name} ${surname}`
  }
  return name ?? surname ?? email ?? ''
}
